export const tdsAmountValidate = (tdsArray,taxableAmount) => {
    const newErrors = {}; 
    

        const totalBaseAmt =  tdsArray.reduce((total, item) => {
            const baseAmount = parseFloat(item?.bsAmt)
            return total + (baseAmount || 0); 
        }, 0);

        tdsArray.forEach((tds, index) => {
          if (parseFloat(totalBaseAmt) > parseFloat(taxableAmount)) {
            newErrors[`tds.${index}.amountTotal`] =
              "Total Amount Should be lessthen or equal taxable amount!";
            }
        });
      return newErrors;
    };
  